import './common.scss';
import BasePlayerUI from '../player-ui';
import Layout from './layouts/layout';
import Components from './components';
import Utils from './utils';
import Assets from './assets';

class PlayerUI extends BasePlayerUI {

}

// export Layout as a static property on player UI
PlayerUI.Layout = Layout;

// export Components as a static property on player UI
PlayerUI.Components = Components;

// export Utils as a static property on player UI
PlayerUI.Utils = Utils;

// export Assets as a static property on player UI
PlayerUI.Assets = Assets;

export default PlayerUI;
